import axios from "axios";
import { apiClient } from "./apiClient";

const getApiUrl = () => {
    if (process.env.REACT_APP_IS_LOCAL_DEV === "true") {
        return "http://localhost:8000/api/v1";
    }
    const hostname = window.location.hostname;
    if (hostname.includes("ngrok-free.app")) {
        return `https://${hostname}/api/v1`;
    }
    return process.env.REACT_APP_API_URL || "https://backend.app.juricapital.com.br/api/v1";
};

// Plain axios instance — no auth interceptor. Used for public endpoints only.
const publicClient = axios.create({
    baseURL: getApiUrl(),
    headers: {
        "X-API-Key": process.env.REACT_APP_API_KEY,
    },
});

const cedenteDocumentoService = {
    // Public endpoint — no JWT required.
    // formData fields: nome, cpf, telefone, email, sindicato_slug, ctps (optional), ppp (optional)
    submitRecalculo: async (processoId, formData) => {
        const response = await publicClient.post(
            `/cedente-documentos/recalculo/${processoId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        return response.data;
    },

    uploadDocumento: async (cedenteId, tipoGrupo, tipoDoc, file) => {
        const fd = new FormData();
        fd.append("cedente_id", cedenteId);
        fd.append("tipo_grupo", tipoGrupo);
        fd.append("tipo_doc", tipoDoc);
        fd.append("file", file);
        const response = await apiClient.post("/cedente-documentos/upload", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    },

    getDocsByCedente: async (cedenteId, processoCedenteId, tipoGrupo = null) => {
        const params = { processo_cedente_id: processoCedenteId };
        if (tipoGrupo) params.tipo_grupo = tipoGrupo;
        const response = await apiClient.get(`/cedente-documentos/cedente/${cedenteId}`, { params });
        return response.data;
    },

getDownloadUrl: async (docId) => {
        const response = await apiClient.get(`/cedente-documentos/${docId}/download`);
        return response.data.url;
    },

    criarCardCrm: async (cedenteId, processoCedenteId) => {
        const response = await apiClient.post("/cedente-documentos/crm/criar-card", {
            cedente_id: cedenteId,
            processo_cedente_id: processoCedenteId,
        });
        return response.data;
    },

    enviarDocsCrm: async (cedenteId, processoCedenteId, targetStatus = null) => {
        const response = await apiClient.post("/cedente-documentos/crm/enviar-docs", {
            cedente_id: cedenteId,
            processo_cedente_id: processoCedenteId,
            target_status: targetStatus,
        });
        return response.data;
    },
};

export default cedenteDocumentoService;
